<template>
  <el-dialog title="编辑跟踪单号"
             width="430px"
             :visible.sync="visibleValue"
             :close-on-press-escape="false"
             :close-on-click-modal="false"
             :modal-append-to-body="true"
             :append-to-body="true"
             @closed="closedCallback">
    <el-form inline ref="editForm">
      <el-form-item label="">
        <el-input v-model="editFormData.nos" placeholder="请输入跟踪单号"/>
      </el-form-item>
      <el-form-item label="">
        <el-button type="primary" @click="clickSave">保存</el-button>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script>
import {mixinsDialog} from "my-element-mixins";
import {isArray, isObject} from "my-tools-kit";

export default {
  name: "editClientNos",
  mixins:[mixinsDialog],
  props:{
    beforeOrderId:[String,Number],//预报订单id
    nos:String,//客户单号
  },
  data(){
    return {
      editFormData:{
        nos:""
      },
    }
  },
  watch:{
    nos(val){
      this.editFormData.nos = val;
    },
  },
  methods:{
    clickSave(){
      // let formName = "editForm";
      // this.$refs[formName].validate((valid) => {
      //   if (!valid) return this.$message.error('请完善表单');
      // })
      this.saveNos();
    },
    saveNos() {
      this.loading = true;
      let url = "/api/carrier/order/editForecastedOrderOutNos";
      let data = {
        "id": this.beforeOrderId||"",//预报订单id
        "outNos": this.editFormData.nos||"",//客户单号
      };
      return this.axios.post(url,data)
        .then(res=>{
          res = isObject(res.data) ? res.data : {};
          if(res.code !== 200) return Promise.reject(new Error(res.message));
          return res;
        })
        .then(res => {
          this.loading = false;
          this.$message.success("保存成功");
          this.closedDialog();
          this.$emit("success");
          return res;
        })
        .catch((res) => {
          this.loading = false;
          this.$message.info(res.message || "服务器繁忙");
        });
    },
  },
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/orderManagement/components/editClientNos.vue